import React from 'react'
import ReactDOM from 'react-dom'
import { StoreProvider } from 'easy-peasy'
import './i18n'

import * as serviceWorker from './serviceWorker'
import './index.css'

import store from './store'
import App from './App'

ReactDOM.render(
    <React.StrictMode>

        <StoreProvider store={store}>
            <React.Suspense fallback="loading">
                <App />
            </React.Suspense>
        </StoreProvider>

    </React.StrictMode>,
    document.getElementById('root')
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
